import { UntypedFormControl } from '@angular/forms';
import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TimeFrame, TIMEFRAMES } from '@huge-monorepo/hip/domain';
import { TimePeriod, TIMEPERIODS } from '@huge-monorepo/hip/domain';

@Component({
  selector: 'tools-time-frame-selector',
  templateUrl: './time-frame-selector.component.html',
  styleUrls: ['./time-frame-selector.component.scss'],
})
export class TimeFrameSelectorComponent implements OnInit {
  TimeFrames = TIMEFRAMES.filter((elem: TimeFrame) => {
    return [1, 2, 3, 4, 5, 6, 7].includes(elem.iD);
  });
  TimePeriods = TIMEPERIODS.filter((elem: TimePeriod) => {
    return [2, 3, 4].includes(elem.iD);
  });
  timeframeValue: string = '';

  @Input() selectedInterval: number = 1;
  @Input() selectedTimeFrame: TimeFrame;
  @Input() selectedTimePeriod: TimePeriod;
  @Input() timeFrameOptions: number[];
  @Input() timePeriodOptions: number[];
  @Input() showTimePeriod: boolean = true;
  @Input() disableTimeFrame: boolean = false;

  compareWith: Function;
  @Output() intervalChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() timeFrameChanged: EventEmitter<TimeFrame> = new EventEmitter<TimeFrame>();
  @Output() timePeriodChanged: EventEmitter<TimePeriod> = new EventEmitter<TimePeriod>();
  selectTimeFrameFormControl = new UntypedFormControl('');
  selectTimePeriodFormControl = new UntypedFormControl('');
  constructor() {}

  ngOnInit() {
    this.compareWith = this.compareWithFn;
    if (this.timeFrameOptions && this.timeFrameOptions.length > 0) {
      this.TimeFrames = TIMEFRAMES.filter((elem: TimeFrame) => {
        return this.timeFrameOptions.includes(elem.iD);
      });
    }

    if (this.timePeriodOptions && this.timePeriodOptions.length > 0) {
      this.TimePeriods = TIMEPERIODS.filter((elem: TimePeriod) => {
        return this.timePeriodOptions.includes(elem.iD);
      });
    }
    if (!this.selectedTimePeriod) this.selectedTimePeriod = this.TimePeriods[0];
    this.selectTimePeriodFormControl = new UntypedFormControl(this.selectedTimePeriod);
    if (!this.selectedTimeFrame) this.selectedTimeFrame = this.TimeFrames[0];
    this.selectTimeFrameFormControl = new UntypedFormControl(this.selectedTimeFrame);
  }

  /**
   *
   * @param eve CustomEvent on input change
   */
  intervalInputChanged(eve) {
    this.selectedInterval = eve.target.value;
    this.intervalChanged.emit(this.selectedInterval);
  }

  /**
   *
   * @param name Primary key of the Time Frame selected
   */
  timeFrameInputChanged($event: any) {
    //let name = $event.value;
    console.log('TIME:', this.selectTimeFrameFormControl.value.iD);
    this.timeFrameChanged.emit(this.TimeFrames.find((x: TimeFrame) => x.iD == this.selectTimeFrameFormControl.value.iD));
  }

  /**
   *
   * @param name Primary key of the Time Period selected
   */
  timePeriodInputChanged($event) {
    this.timePeriodChanged.emit(this.TimePeriods.find((x: TimePeriod) => x.iD == this.selectTimePeriodFormControl.value.iD));
  }

  /**
   *
   * @param o1 Either TimePeriod | TimeFrame object
   * @param o2 Either TimePeriod | TimeFrame object
   * @returns boolean to check equivalence
   */
  compareWithFn = (o1: TimePeriod | TimeFrame, o2: TimePeriod | TimeFrame): boolean => {
    return o1 == o2;
  };
}
